export const INITIALS_MERCHANT_LOGO_CODES = [
  '5aa0910b-6ffe-459b-aae5-f866ca9e2669',
  '4c820294-6755-408c-9362-bd8df7ae9c72',
  'c22e7913-3584-11ed-b532-84557fde91c5',
  'fbf5dfee-2675-4984-9c4c-ee1f2f714bcd',
  '01c90a70-0757-447a-84e3-63d479d6d5af',
  'dfdd7d0d-a073-4264-bce2-111efe47c96e',
  '8bad0443-0ef3-4331-bf07-95947c57373c',
  '5bf803a1-616b-4487-b7f8-4eb76363b338',
  '74c100db-55ed-4938-8877-9b7f3990093e',
  '2c52d8eb-0cb7-4fc3-96c2-5cd6bc65707e',
  '2f2f560b-df47-4a0f-ad23-368fdb57d763',
  '6f879a00-8cb3-4383-8947-93c9fbfd1f73',
  '34c15d0e-213a-4c7f-a24b-d7619dd2c27b',
  'c56f7f53-f02f-440b-a4ba-7d15247052ab',
  'd1da6f6c-792d-4e21-83da-a1cff4c4350b',
  'adbfa1ce-e8d7-4df4-8bb9-f6487d0595ff',
  '657325d3-687f-48a0-8a91-efcab2844c51',
  '82ab0a8d-a612-44f7-84d7-1f5edc292b30',
  'e4c9ac10-d82c-4c01-b68e-92a77095b360',
  '5a551153-aedf-4a91-85cd-bf2293afbbd4',
  '451f8b7c-219e-47d7-9113-25e0e54eefc7',
  '40cd5b31-ba7c-4776-8656-4cf2cf3b2ef6',
  '2b2234b4-ecf7-4b3d-aa24-3825aeaf98ca'
];

export const shouldShowCategoryInitials = (
  merchantName: string | undefined, 
  merchantLogoCode?: string
): boolean => {
  const normalizedName = merchantName?.toLowerCase()?.trim();
  
  if (normalizedName === 'unknown' || normalizedName === 'none') {
    return true;
  }
  
  if (merchantLogoCode && INITIALS_MERCHANT_LOGO_CODES.includes(merchantLogoCode)) {
    return true;
  }
  
  return false;
};

export const getInitials = (text: string): string => {
  if (!text) return 'UN';
  const words = text.trim().split(/\s+/).filter(word => word.length > 0);
  if (words.length === 0) return 'UN';
  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }
  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};